import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function IncomingCall({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>IncomingCall</title>
      <path
        d="M12.8432 18.1568C14.5559 19.0188 16.5723 19.6404 18.9375 19.9063C19.5115 19.9709 20 19.511 20 18.9334V16.7808C20 16.3219 19.6877 15.9219 19.2425 15.8106L16.5493 15.1373C16.2085 15.0521 15.848 15.152 15.5996 15.4004L12.8432 18.1568ZM12.8432 18.1568C9.72749 16.5888 7.61705 14.225 6.24117 11.7588M6.24117 11.7588C4.93032 9.40926 4.28622 6.96674 4.07481 5.03084C4.01343 4.46884 4.46855 4 5.03389 4H7.1802C7.65688 4 8.06729 4.33646 8.16078 4.80388L8.89504 8.47521C8.96061 8.80307 8.85799 9.14201 8.62157 9.37843L6.24117 11.7588Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
      />
      <path
        d="M14 10H13.25C13.25 10.4142 13.5858 10.75 14 10.75V10ZM18 10.75C18.4142 10.75 18.75 10.4142 18.75 10C18.75 9.58579 18.4142 9.25 18 9.25V10.75ZM14.75 6C14.75 5.58579 14.4142 5.25 14 5.25C13.5858 5.25 13.25 5.58579 13.25 6H14.75ZM20.5303 4.53033C20.8232 4.23744 20.8232 3.76256 20.5303 3.46967C20.2374 3.17678 19.7626 3.17678 19.4697 3.46967L20.5303 4.53033ZM14 10.75H18V9.25H14V10.75ZM14.75 10V6H13.25V10H14.75ZM19.4697 3.46967L13.4697 9.46967L14.5303 10.5303L20.5303 4.53033L19.4697 3.46967Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
